import {VscodeIcon} from '@primer/octicons-react'
import type {ComponentType, SVGProps} from 'react'
import {ClaudeCodeIcon} from '@github-ui/custom-icons/ClaudeCodeIcon'
import {CodexIcon} from '@github-ui/custom-icons/CodexIcon'

export type CodingToolsSettingsProps = {
  tools: string[]
  settings: Record<string, boolean>
  updatePath: string
}

export type CodingToolUpdateResult = {
  success: boolean
  tool: string
  enabled: boolean
}

export type ToolIcon = ComponentType<SVGProps<SVGSVGElement>>

const TOOL_DISPLAY_NAMES: Record<string, string> = {
  copilot_vs_code: 'Copilot for VS Code',
  claude_code_web: 'Claude Code (Web)',
  codex_desktop_app: 'Codex Desktop App',
}

const TOOL_DESCRIPTIONS: Record<string, string> = {
  copilot_vs_code: 'Opens in VS Code',
  claude_code_web: 'Opens in claude.ai',
  codex_desktop_app: 'Opens in the Codex desktop app',
}

const TOOL_ICONS: Record<string, ToolIcon> = {
  copilot_vs_code: VscodeIcon,
  claude_code_web: ClaudeCodeIcon,
  codex_desktop_app: CodexIcon,
}

export function getToolDisplayName(tool: string): string {
  return TOOL_DISPLAY_NAMES[tool] ?? tool
}

export function getToolDescription(tool: string): string {
  return TOOL_DESCRIPTIONS[tool] ?? ''
}

export function getToolIcon(tool: string): ToolIcon | undefined {
  return TOOL_ICONS[tool]
}
